<template>
  <v-col cols="12" class="pr-3 pb-5">
    <sidebar-row>
      <v-row no-gutters justify="center">
        <v-col cols="12" class="pa-1" style="border: 1px solid rgba(0,0,0,0.12)">
          <v-row no-gutters>
            <v-col cols="1" class="px-2">
              <v-icon :color="attachment.iconColor" style="font-size: 20px">
                {{ attachment.icon }}
              </v-icon>
            </v-col>
            <v-col class="pt-1" cols="auto">
              <v-row no-gutters>
                <v-tooltip
                  left
                  content-class="pa-0"
                  color="rgba(255,255,255,0)"
                  :disabled="!attachment.is_photo"
                  :allow-overflow="true"
                >
                  <template #activator="{ on }">
                    <p class="ma-0 pl-1" style="font-size: 14px; font-weight: 500; color: #202124" v-on="on">
                      {{ attachment.name }}
                    </p>
                  </template>
                  <img :src="attachment.thumbnailUrl" :alt="attachment.name" />
                </v-tooltip>
              </v-row>
              <v-row no-gutters>
                <p
                  class="ma-0 pl-1"
                  style="font-style: italic; font-size: 12px; font-weight: 300; color: rgba(0, 0, 0, 0.59)"
                >
                  {{ attachment.filename }}
                </p>
              </v-row>
            </v-col>
            <v-spacer />
            <v-col v-if="attachment.is_photo" cols="auto">
              <v-tooltip bottom color="font">
                <template #activator="{ on: onTooltip }">
                  <v-btn small icon v-bind="$attrs" v-on="{ ...onTooltip }" @click="onAttachmentPreview(attachment.id)">
                    <v-icon color="rgba(0,0,0,0.7)" small>
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </template>
                {{ $i18n.t('button.filePreview') }}
              </v-tooltip>
            </v-col>
            <v-col cols="auto">
              <dots-menu
                :items="attachment.dotsItems"
                @openDocument="openDocument(attachment.id)"
                @setProfileImage="setProfileImage"
                @delete="openDialog(attachment)"
                @download="downloadAttachment(attachment.id)"
                font-size="18px"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="1"> </v-col>
            <v-col class="pt-2 pl-1">
              <v-row no-gutters v-for="(attribute, idx) of computedFormSchema" :key="idx" class="pb-1" align="center">
                <v-col cols="auto" class="text-body-2 text-left pr-2" style="color: rgba(0,0,0,0.6)">
                  {{ `${attribute.label}:` }}
                </v-col>
                <v-col
                  cols="auto"
                  class="text-body-2 text-left"
                  :style="
                    `color: ${getAttributeValueColor(attribute, 'text') || 'rgba(0,0,0,0.7)'};
                    background-color: ${getAttributeValueColor(attribute, 'background') || 'unset'};
                    font-weight: 500;
                    border-radius: 5px;
                    padding-left: 5px;
                    padding-right: 5px;
                    padding-top: 2px;
                    padding-bottom: 2px;`
                  "
                >
                  {{ `${getAttributeValue(attribute)}` }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </sidebar-row>
    <image-lightbox :items="currentImage" :visible.sync="imagePreviewVisible" enableZoom></image-lightbox>
  </v-col>
</template>
<script>
import { call } from 'vuex-pathify';
import prepareAttributesFeatureCardMixin from '@/mixins/prepareAttributesFeatureCardMixin';
import DotsMenu from '@/components/DotsMenu';
import SidebarRow from '@/components/SidebarRow';
import { get } from 'vuex-pathify';
export default {
  name: 'TheAttachmentExpanded',
  components: {
    DotsMenu,
    SidebarRow,
    ImageLightbox: () => import('@/components/ImageLightbox'),
  },
  mixins: [prepareAttributesFeatureCardMixin],
  props: {
    attachment: {
      type: Object,
      required: true,
    },
    formSchema: {
      type: Array,
      default: () => {
        return [];
      },
    },
    layerId: {
      type: [String, Number],
      required: true,
    },
    featureId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    documentationLayerId: get('admin/modulesMapping@documentation.documentation_layer_id'),
    token: get('authentication/token'),
    currentLayer: get('layers/layers@:layerId'),
    computedFormSchema() {
      return this.formSchema.filter(attribute => !['name', 'filename'].includes(attribute.attribute));
    },
  },
  data: () => ({
    values: {},
    imagePreviewVisible: false,
    currentImage: undefined,
  }),
  methods: {
    downloadAttachment: call('relations/downloadAttachment'),
    editDatasourceFeature: call('layers/editDatasourceFeature'),
    getAttributeValue(attribute) {
      return this.getAttributeTextValue(this.values, attribute);
    },
    openDocument(attachment_id) {
      this.$router.push({
        name: 'layerFeature',
        params: { lid: this.documentationLayerId, fid: attachment_id },
      });
    },
    async setProfileImage() {
      await this.editDatasourceFeature({
        datasource: this.currentLayer.data_source_name,
        id: this.featureId,
        body: {
          ...this.getValues(this.currentLayerFormSchema, {}),
          [this.currentLayer.image_attribute]: this.attachment.fileUrl,
        },
        params: { layer_id: this.currentLayer.id },
      });
      this.$root.$emit('refreshTableData');
      this.$root.$emit('refreshFormData');
    },
    getAttributeValueColor(attribute, type) {
      if (attribute.colors) {
        const value = this.values[attribute.attribute];
        const index = attribute.items.findIndex(item => item === value);
        const color = attribute.colors[index];
        if (type === 'text') {
          const textColor = this.$_isHexColorLight(color || '#ffffff') ? '#202124' : 'white';
          return textColor;
        }
        return color;
      }
      return undefined;
    },
    openDialog(file) {
      this.$emit('deleteFile', file);
    },
    onAttachmentPreview(id) {
      this.currentImage = [
        `${process.env.VUE_APP_API_URL}/attachments/${id}/file?as_attachment=false&token=${this.token}`,
      ];
      this.imagePreviewVisible = true;
    },
  },
  mounted() {
    this.values = this.getValues(this.computedFormSchema, this.attachment.properties);
  },
};
</script>
